import { BASE_URL } from '../../constants/baseUrl';
import axiosInstance from '../../utils/axiosInstance';
import logger from '../../utils/logger';

class ParcelDimensionsService {
  /**
   * Fetches all parcel dimensions from the API
   * @returns {Promise} Axios response with parcel dimensions data
   */
  fetchParcelDimensions = async () => {
    try {
      const response = await axiosInstance.get(
        `${BASE_URL}/v1/lookups/parcel_dimensions`,
      );
      return response;
    } catch (error) {
      logger.error('API Error:', error);
      throw error;
    }
  };

  /**
   * Gets a specific parcel dimension by ID
   * @param {number} id - Parcel dimension ID
   * @returns {Promise} Axios response
   */
  getParcelDimension = (id) => {
    return axiosInstance.get(`${BASE_URL}/v1/lookups/parcel_dimensions/${id}`);
  };

  /**
   * Creates a new parcel dimension
   * @param {Object} parcelDimensionData - Parcel dimension data
   * @returns {Promise} Axios response
   */
  addParcelDimension = (parcelDimensionData) => {
    return axiosInstance.post(
      `${BASE_URL}/v1/lookups/parcel_dimensions`,
      parcelDimensionData,
    );
  };

  /**
   * Updates an existing parcel dimension
   * @param {number} id - Parcel dimension ID
   * @param {Object} parcelDimensionData - Updated parcel dimension data
   * @returns {Promise} Axios response
   */
  updateParcelDimension = (id, parcelDimensionData) => {
    return axiosInstance.put(
      `${BASE_URL}/v1/lookups/parcel_dimensions/${id}`,
      parcelDimensionData,
    );
  };

  /**
   * Deletes a parcel dimension
   * @param {number} id - Parcel dimension ID
   * @returns {Promise} Axios response
   */
  deleteParcelDimension = (id) => {
    return axiosInstance.delete(
      `${BASE_URL}/v1/lookups/parcel_dimensions/${id}`,
    );
  };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new ParcelDimensionsService();
